// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import {
	ButtonLoadMore,
	DraftFilters,
	CheckboxControlled as Checkbox,
	PlayerInfo,
	SwitchButton,
	ButtonPrimary,
	ButtonSecondary,
	ModalContainer,
	ModalInnerTitle,
} from '../../components';
import ArrowUp from '../../components/Icons/ArrowUp';
import ArrowDown from '../../components/Icons/ArrowDown';
import Table, { TBody, Tr, Td } from '../../components/TableX';
import {
	PageTitle,
	AdsContainer,
	ThStat,
	CoachLockIcon,
	DragIcon,
} from '../../components';
import Ad from "../../components/Ad";
import { DraftTableHeader } from "../../components";
import DraftOrderWidget from "../../components/DraftOrderWidget";
import DraftLayout from '../../components/Draft/DraftLayout';
import Aside from '../../components/Draft/Aside';
import THead from '../../components/Draft/THead';
import TrRow from '../../components/Draft/TrRow';
import TdYourTeam from '../../components/Draft/TdYourTeam';
import TdStat from '../../components/Draft/TdStat';
import ThIgnore from '../../components/Draft/ThIgnore';
import Expander from '../../components/Draft/Expander';
import DraftTitleContainer from '../../components/Draft/DraftTitleContainer';
import DraftOrder from '../../components/Draft/DraftOrder';
import ThToolTip from '../../components/ThToolTip';
import { withDraftCore } from "../../components/Draft/withDraftCore";
import type { TDraftPassedProps } from "../../components/Draft/withDraftCore";
import { below } from '../../assets/css/media';
import * as actions from "../../modules/actions";
import { ResetListButton } from './preDraft/resetListButton';
import TopBar from './preDraft/topBar';
import ThStatIgnored from './preDraft/thStatIgnored';


const ConfirmModalContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 1em 2em 40px;
	${below.desktop`
		${css`
			margin: 1em 0;
		`}
	`}
`;

const ButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 1em 0;
	button {
		width: 200px;
		margin: 0 .5em;
	}
`;

type State = {
	draft_order_widget_open: boolean,
	draft_guide_widget_open: boolean,
	show_ignore_confirm_modal: boolean,
}

type Props = TDraftPassedProps & {
	resetQueue: Function,
}

class PreDraftContainer extends React.Component<Props, State> {
	state = {
		draft_order_widget_open: false,
		draft_guide_widget_open: false,
		show_ignore_confirm_modal: false,
	};

	onToggleDraftOrderWidget() {
		const draft_order_widget_open = !this.state.draft_order_widget_open;
		this.setState({ draft_order_widget_open });
	}

	onToggleDraftGuideWidget() {
		const draft_guide_widget_open = !this.state.draft_guide_widget_open;
		this.setState({ draft_guide_widget_open });
	}

	handleIgnoreConfirmModal(player_id) {
		const { show_ignore_confirm_modal } = this.state;
		this.setState({
			show_ignore_confirm_modal: !show_ignore_confirm_modal,

		});
	}

	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'onToggleDraftOrderWidget',
			'onToggleDraftGuideWidget',
			'handleIgnoreConfirmModal',
			'onClickIgnore',
		]);
	}

	get players() {
		const { players, orderByComparator, players_filter, has_filters } = this.props;
		const players_copy = players.slice();

		if (has_filters) {
			return players_copy.filter(players_filter).sort(orderByComparator);
		}

		const { players_show_limit } = this.props;

		return players_copy.sort(orderByComparator).slice(0, players_show_limit);
	}

	get is_sidebar_open() {
		const { draft_order_widget_open, draft_guide_widget_open } = this.state;
		return draft_order_widget_open || draft_guide_widget_open;
	}

	get load_more_btn() {
		if (this.props.load_more_is_hidden) {
			return null;
		}

		return <ButtonLoadMore onClick={this.props.onLoadMoreClick}>
			Load More <ArrowDown />
		</ButtonLoadMore>;
	}

	get table_header() {
		const { order_by_desc, onSortColumnChange, isActiveTab, table_keys } = this.props;
		const cells = table_keys.map(({ key, prop, tooltip }) => (
			<ThStat
				className={`${isActiveTab(prop)} player-stats`}
				onClick={() => onSortColumnChange(prop)} key={key}>
				<div>
					<div className="highlighter" />
					<span className="column-name">{key}</span>
					{isActiveTab(prop) && !order_by_desc ?
						<ArrowUp color='#ffffff' className='top' /> : null}
					{isActiveTab(prop) && order_by_desc ?
						<ArrowDown color='#ffffff' className='down' /> : null}
					{tooltip && <ThToolTip text={tooltip} />}
				</div>
			</ThStat>
		));

		const { is_coach_active } = this.props,
			draft_order_key = 'draft_order';

		return (
			<THead className={is_coach_active ? 'coach-stats' : 'basic-stats'}>
				<Tr>
					<ThIgnore>
						Drag &
						<br />
						Drop
					</ThIgnore>
					<ThStat
						width="100"
						className={`${isActiveTab(draft_order_key)}`}
						onClick={() => onSortColumnChange(draft_order_key)}>
						<div>
							<div className="highlighter" />
							<span className="column-name">Draft position</span>
							{isActiveTab(draft_order_key) && !order_by_desc ?
								<ArrowUp color='#ffffff' className='top' /> : null}
							{isActiveTab(draft_order_key) && order_by_desc ?
								<ArrowDown color='#ffffff' className='down' /> : null}
						</div>
					</ThStat>
					<ThStatIgnored />
					{cells}
					<ThIgnore>Ignore</ThIgnore>
				</Tr>
			</THead>
		);
	}

	getTableMessage(message) {
		const size_of_predefined_columns = 3,
			total_columns_size = _.size(this.props.table_keys) + size_of_predefined_columns;

		return (
			<TBody>
				<Tr>
					<Td align="center" colSpan={total_columns_size}>
						<Expander>{message}</Expander>
					</Td>
				</Tr>
			</TBody>
		);
	}

	get ignore_confirm_modal() {
		return (
			<ModalContainer header_text="CONFIRM OFFER" onClick={this.handleIgnoreConfirmModal}>
				<ModalInnerTitle>
					CONFIRM...
				</ModalInnerTitle>
				<ConfirmModalContent>
					Are you sure you want to ignore this player?
				</ConfirmModalContent>
				<ButtonsWrapper>
					<ButtonSecondary onClick={this.handleIgnoreConfirmModal}>
						CANCEL
					</ButtonSecondary>
					<ButtonPrimary
						onClick={this.onClickIgnore}
					>
						CONFIRM OFFER
					</ButtonPrimary>
				</ButtonsWrapper>

			</ModalContainer>
		);
	}

	get table_body() {
		const {
			is_pending_players,
			pre_draft_list_size,
			isActiveTab,
		} = this.props;

		if (is_pending_players) {
			return this.getTableMessage('Loading, please wait...');
		}

		const players_list = this.players;

		if (!is_pending_players && _.isEmpty(players_list)) {
			return this.getTableMessage(
				'No Players within the player pool fit your search criteria'
			);
		}

		const {
			onChangePlayerOrder,
			updatePlayerPreDraftListOrder,
			table_keys,
			has_assistant_coach,
			is_coach_active,
			is_dnd_allowed,
			onDrop,
			onDragEnd,
			onDragLeave,
			onDragOver,
			onDragEnter,
			onDragStart,
			onEnableDrag,
			onDisableDrag,
		} = this.props;

		const cells = players_list.map(player => {
			const { draft_order } = player;
			const is_ignored = !draft_order;
			const is_dnd_enabled = is_dnd_allowed && !is_ignored;

			return (
				!is_ignored ? (<TrRow
					draggable="false"
					data-drag-and-drop-enabled={is_dnd_enabled}
					data-player-id={player.id}
					onDrop={onDrop}
					onDragEnd={onDragEnd}
					onDragEnter={onDragEnter}
					onDragLeave={onDragLeave}
					onDragOver={onDragOver}
					onDragStart={onDragStart}
					className={is_ignored ? 'is-ignored' : null}
					key={player.id}
				>
					<Td>
						<DragIcon
							onMouseEnter={onEnableDrag}
							onMouseLeave={onDisableDrag}
							disabled={!is_dnd_enabled}
						/>
					</Td>
					<TdYourTeam alignText="right">
						<div>
							<DraftOrder
								disabled={is_ignored}
								onChange={onChangePlayerOrder}
								name="draft_order"
								data-id={player.id}
								value={draft_order || '-'}
							/>
							<div>
								<SwitchButton
									up={true}
									disabled={is_ignored || draft_order === 1}
									data-order={parseInt(draft_order, 10) - 1}
									data-id={player.id}
									onClick={updatePlayerPreDraftListOrder}
								>
									<ArrowUp size='1.5' />
								</SwitchButton>
								<SwitchButton
									disabled={is_ignored || pre_draft_list_size === draft_order}
									data-order={parseInt(draft_order, 10) + 1}
									data-id={player.id}
									onClick={updatePlayerPreDraftListOrder}
								>
									<ArrowDown size='1.5' />
								</SwitchButton>
							</div>
						</div>
					</TdYourTeam>
					<TdStat>
						<PlayerInfo className="player-info" player={player} />
					</TdStat>
					{table_keys.map(({ key, prop, prop_sub }) => {
						const renderValue = () => (
							<React.Fragment>
								{_.get(player, prop, '--')} {prop_sub
									? `(${_.get(player, prop_sub, '--')})`
									: null
								}
							</React.Fragment>
						);
						return (
							<TdStat className={`player-stats ${isActiveTab(prop)}`} key={key}>
								{is_coach_active && !has_assistant_coach ? (
									<CoachLockIcon />
								) : renderValue()}
							</TdStat>
						);
					})}
					<Td>
						<Checkbox
							onChange={this.onClickIgnore}
							checked={is_ignored}
							name={`ignore-${player.id}`}
						/>
					</Td>
				</TrRow>) : null
			);
		});

		return <TBody>{cells}</TBody>;
	}

	onClickIgnore(event) {
		const { currentTarget: { name, checked } } = event;

		if (checked && !window.confirm('Are you sure you want to ignore this player?')) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}

		const { league: { team_id } } = this.props;
		const player_id = parseInt(_.last(name.split('-')), 10);

		const togglePlayerInList = this.props[
			!checked ? 'addPlayerToPreDraftList' : 'removePlayerFromPreDraftList'
		];

		togglePlayerInList({ player_id, team_id });
	}

	render() {
		const {
			squads,
			positions,
			playerStatuses,
			league: { draft_status, name },
			league,
			match: { params: { league_id } },
			coach_stats_list,
			order_by_desc,
			resetQueue,
			onToggleOrder,
			onFiltersChange,
			onTabChange,
			onSearchSubmit,
			onSelectChange,
			is_coach_active,
			server_time_diff,
		} = this.props;

		if (draft_status === 'active') {
			return <Redirect to={`/league/${league_id}/team/live-draft`} />;
		}

		if (draft_status === 'complete') {
			return <Redirect to={`/league/${league_id}/team`} />;
		}

		const
			{
				draft_order_widget_open,
				show_ignore_confirm_modal,
			} = this.state;

		// F2P1-62534: Display even in mobile
		// if(isMobile()) {
		// 	return (
		// 		<React.Fragment>
		// 			<GoToApp page_name="Pre Draft" />
		// 		</React.Fragment>
		// 	);
		// }

		return (
			<div>
				<TopBar time_shift={server_time_diff} league={league} />
				<AdsContainer>
					<Ad
						adUnit='myleagues/pre-draft'
						size='top'
					/>
				</AdsContainer>
				<DraftLayout sidebar_open={this.is_sidebar_open}>
					<div>
						{show_ignore_confirm_modal && this.ignore_confirm_modal}
						<DraftTitleContainer>
							<PageTitle>Pre Draft for {name}</PageTitle>
						</DraftTitleContainer>
						<DraftFilters
							handleChange={onFiltersChange}
							handleSubmit={onSearchSubmit}
							onToggleOrder={onToggleOrder}
							order_by_desc={order_by_desc}
							squads={squads}
							positions={positions}
							statuses={playerStatuses}
							is_show_drafted={false}
							is_show_ignored={true}
						/>
						<DraftTableHeader
							onTabClick={onTabChange}
							onSelectChange={onSelectChange}
							isCoachActive={is_coach_active}
							selectOptions={coach_stats_list}
						>
							<ResetListButton onClick={resetQueue} >
								RESET LIST
							</ResetListButton>
						</DraftTableHeader>
						<Table>
							{this.table_header}
							{this.table_body}
						</Table>
						{this.load_more_btn}
					</div>

					<Aside>
						<DraftOrderWidget
							onToggle={this.onToggleDraftOrderWidget}
							widget_open={draft_order_widget_open}
						/>
					</Aside>
				</DraftLayout>
				<AdsContainer>
					<Ad
						adUnit='myleagues/pre-draft'
						size='bottom'
					/>
				</AdsContainer>
			</div>
		);
	}
}

const on_clear_msg = "This action will reset your pre-draft list to " +
	"its original state before ANY of your changes. Are you sure you " +
	"want to continue? This action cannot be undone!!!";

const mapDispatchToProps = (dispatch, props) => {
	const { league: { team_id, id } } = props;

	return {
		resetQueue: () => (
			team_id
			&& window.confirm(on_clear_msg)
			&& dispatch(actions.teamsDraft.postResetPreDraftList({ team_id, league_id: id }))
			&& props.onResetFilterClick()
		)
	};
};

export const PreDraft = withDraftCore(connect(
	null,
	mapDispatchToProps,
)(PreDraftContainer));

export default PreDraft;


// WEBPACK FOOTER //
// ./src/pages/league/PreDraft.js